export default __webpack_public_path__ + "static/b_wuhrl-afd847845d2d06b196232781b0a76955.jpg";